module.exports = __webpack_public_path__ + "img/central_couture-min.e2cd06a0.jpg";